import getRouterView from '@/router/helpers';

export default {
    path: '/invoice',
    meta: {
        requiresAuth: true,
        title: 'Search',
        documentTitle: 'Invoices',
    },
    component: getRouterView(),
    children: [
        {
            path: '',
            name: 'InvoiceReconciliationSearch',
            meta: {
                title: 'Invoices',
                documentTitle: 'Invoices',
            },
            component: () => import( /* webpackChunkName: "InvoiceReconciliation" */ '@/views/Invoice/Search' ),
        },
        {
            path: 'create',
            name: 'InvoiceReconciliationCreate',
            meta: {
                title: 'Invoice Create',
                documentTitle: 'Invoice Create',
            },
            component: () => import( /* webpackChunkName: "InvoiceReconciliation" */ '@/views/Invoice/Create' ),
        },
        {
            path: ':id',
            name: 'InvoiceReconciliationDetail',
            meta: {
                title: 'Invoice Reconciliation Detail',
                documentTitle: 'Invoice Reconciliation',
            },
            component: () => import( /* webpackChunkName: "InvoiceReconciliation" */ '@/views/Invoice/Detail' ),
        },
    ],
};
